import { render, staticRenderFns } from "./PaymentsFooter.vue?vue&type=template&id=966e6b9a&scoped=true&"
import script from "./PaymentsFooter.vue?vue&type=script&lang=js&"
export * from "./PaymentsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966e6b9a",
  null
  
)

export default component.exports